import StoriesPost from '@/components/stories-post/StoriesPost.vue'
import vSelect from 'vue-select'
import { BPaginationNav, BPagination } from 'bootstrap-vue'
import '@/scripts/vue/dayjs'
import VueScrollTo from 'vue-scrollto'
import fetchItems from '@/scripts/vue/api-axios'
import ListStateMixin from '@/mixins/ListStateMixin'

const categoryId = typeof window.category_id === "undefined" ? 3 : window.category_id
const perPageInitial = typeof window.perPageInitial === "undefined" ? 5 : window.perPageInitial

const storiesListConfig = {
    mixins: [ListStateMixin('storiesList')],
    components: {
      StoriesPost,
      vSelect,
      BPaginationNav,
      BPagination
    },
    mounted() {
      this.$Progress.start();
      fetchItems(`/yiifsuccessstories?categoryId=${categoryId}`)
        .then((items) => {
          this.stories = items;
        })
        .then(() => {
          fetchItems(`/yiifcategory/successstories`)
            .then((items) => {
              this.scrollTo('body', 0);

              this.categories = items;
              this.getSelectOptions();
              this.getStoriesTypes()
              this.$Progress.finish();

              // type attribute from url
              const typeParam = parseInt(window.utils.getQueryStringParameter('storiesType'));
              const defaultTypeOption = this.selectTypeOptions[typeParam];
              
              if ( typeParam && defaultTypeOption )
              {
                this.selectedType = defaultTypeOption;
              }
              else
              {
                this.selectedType = this.selectTypeOptions[0];
              }

              // category attribute from url
              const categoryParam = parseInt(window.utils.getQueryStringParameter('storiesCategory'));
              if ( categoryParam )
              {
                const currentCategory = this.selectOptions.filter(option => {
                  return option.id === categoryParam
                });

                this.selectedCategory = currentCategory[0];
              }

              // pagination attribute from url
              const pageParam = window.utils.getQueryStringParameter('storiesPage');
              if ( pageParam )
              {
                this.currentPage = pageParam;
              }

            })
        });
    },
    data: () => ({
      stories: [],
      categories: [],
      selectOptions: [],
      selectTypeOptions: [],
      selectedCategory: null,
      currentPage: 1,
      perPage: perPageInitial,
      selectedType: null,
      scrollerIsScrolling: false
    }),
    computed: {
      itemsForList() {
        return this.filteredItems.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage,
        );
      },
      rows() {
        return this.filteredItems.length
      },
      filteredItems() {
        return this.stories
          .filter(item => {
            if (!this.selectedCategory || !this.selectedCategory.id) return true;
            const articleCategories = new Set(Object.keys(item.category));
            const selectedCategories = this.selectedCategory.categories;
            for(let index = 0; index < selectedCategories.length; index++) {
              if (articleCategories.has(selectedCategories[index].toString())) return true
            }
          })
          .filter(item => {
            if (!this.selectedType || this.selectedType === this.$refs.typeSelect.placeholder) return true
            return item.type === this.selectedType
          })
      },
      isOnePage() {
        return this.rows <= this.perPage
      }
    },
    methods: {
      getSelectOptions() {
        this.categories.map(segment => {
          this.selectOptions.push({
            id: segment.id,
            title: null,
            group: segment.title
          });
          if(segment.children.length !== 0) {
            segment.children.map(category => {
              this.selectOptions.push({
                id: category.id,
                title: category.title,
                categories: category.children,
              });
            })
          }
        })

        /* show all option */
        if ( this.$refs.categorySelect?.placeholder )
        {
          // get Ids of all categories
          const allCategoriesIds = this.categories.map(category => category.id);

          // get placeholder from ref select
          const placeholder = this.$refs.categorySelect.placeholder;

          // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
          const clearOption = {
            categories: allCategoriesIds,
            id: null,
            title: placeholder
          };

          this.selectOptions.unshift(clearOption);

          const defaultCategorySelected = parseInt(window.utils.getQueryStringParameter('storiesCategory')) > 0; 
          if ( ! defaultCategorySelected )
          {
            this.selectedCategory = clearOption;
          }
        }
        /* ___ show all option ___ */
      },
      getPostLink(postCategories) {
        let link = postCategories[categoryId];
        if (this.selectedCategory && this.selectedCategory.id) {
          const categories = new Set(this.selectedCategory.categories);
          for (let key in postCategories) {
            if (categories.has(parseInt(key))) {
              return postCategories[key]
            }
          }
        }
        return link
      },
      getStoriesTypes() {
        const types = new Set();

        /* show all option */
        if ( this.$refs.typeSelect?.placeholder )
        {
          const placeholder = this.$refs.typeSelect.placeholder;
          types.add(placeholder);

          const defaultTypeSelected = parseInt(window.utils.getQueryStringParameter('storiesType')) > 0; 
          if ( ! defaultTypeSelected )
          {
            this.selectedType = placeholder;
          }
          
        }
        /* ___ show all option ___ */

        this.stories.map(item => {
          if ( item.type )
          {
            types.add(item.type)
          }
        })
        this.selectTypeOptions = [...types]
      },
      scrollTo(target, duration) {
        // if not scrolling already
        if ( !this.scrollerIsScrolling )
        {
          // scroll to target with desired duration
          VueScrollTo.scrollTo(target, {
            duration: duration,
            onStart: () => {
              // set scrolling variable
              this.scrollerIsScrolling = true;
            },
            onDone: () => {
              // unset scrolling variable
              this.scrollerIsScrolling = false;
            }
          });
        }
      }
    },
    watch: {
      perPage: function() {
        this.scrollTo('body', 500);
      },
      currentPage: function(newValue, oldValue) {
        this.scrollTo('body', 500);

        // change query string after changing pagination
        if ( newValue != oldValue )
        {
          window.utils.setQueryStringParameter('storiesPage', this.currentPage);
        }
      },
      selectedType: function(newValue, oldValue){

        // get index of new value
        let newIndex = this.selectTypeOptions.indexOf(newValue);
        if ( newIndex > 0 )
        {
          window.utils.setQueryStringParameter('storiesType', newIndex);
        }
        else
        {
          window.utils.setQueryStringParameter('storiesType', 0);
        }

      },
      selectedCategory: function (newValue, oldValue) {

        if ( oldValue !== null && ( oldValue.id != newValue.id ) ) {
          this.currentPage = 1;
        }
  
        if ( newValue.id )
        {
          window.utils.setQueryStringParameter('storiesCategory', newValue.id);
        }
        else
        {
          window.utils.setQueryStringParameter('storiesCategory', 0);
        }

      }
    }
}

export default storiesListConfig